import React from 'react';

import { ComponentInfo } from '@components';

import { useAccountSelectorPlaceholderHelper } from './accountSelector.helper';
import { AccountSelector, Skeletons } from './block';

export const AccountSelectorPlaceholder: React.FC = () => {
	const { isLoading } = useAccountSelectorPlaceholderHelper();

	return (
		<>
			<ComponentInfo name="AccountSelectorPlaceholder" type="placeholder">
				{isLoading ? <Skeletons /> : <AccountSelector />}
			</ComponentInfo>
		</>
	);
};
